import SkeletonComponent from './skeleton.component'

const SkeletonModule = angular.module('cdbl.skeleton', [

])
  .component('cdblSkeleton', SkeletonComponent)
  .name

export default SkeletonModule
